export class Item {
    id : string
    name : string | null
    lowerValue : number | null
    upperValue : number | null
    uom : string | null
    price : number | null
    value : number | null

    constructor(item?: Item) {
        this.id = item?.id || '';
        this.name = item?.name || null;
        this.lowerValue = item?.lowerValue || null;
        this.upperValue = item?.upperValue || null;
        this.uom = item?.uom || null;
        this.price = item?.price || null;
        this.value = item?.value || null;
    }
}

export class Calculation {
    id : string
    name : string | null
    fields : Field[]
    sqft : number
    subTotal : number
    total : number

    constructor(item?: Calculation) {
        this.id = item?.id || '';
        this.name = item?.name || null;
        this.fields = item?.fields || [];
        this.sqft = item?.sqft || 0;
        this.subTotal = item?.subTotal || 0;
        this.total = item?.total || 0;
    }
}

export class Field {
    id : string
    name : string | null
    collection : string | null
    type : string | null
    show : boolean
    required : boolean
    calc : CalcDetail[]
    selection : Item | null
    value : number
    calcGroup : number
    dependency : Dependency | null

    constructor(item?: Field) {
        this.id = item?.id || '';
        this.name = item?.name || null;
        this.collection = item?.collection || null;
        this.type = item?.type || null;
        this.show = item?.show || false;
        this.required = item?.required || false;
        this.calc = item?.calc || [];
        this.selection = item?.selection || null;
        this.value = item?.value || 0;
        this.calcGroup = item?.calcGroup || 3;
        this.dependency = item?.dependency || null;
    }
}

export class CalcDetail {
    type : string | null
    fields : Field[]
    result : Result | null
    value : number

    constructor(item?: CalcDetail) {
        this.type = item?.type || null;
        this.fields = item?.fields || [];
        this.result = item?.result || null;
        this.value = item?.value || 0;
    }
}

export class Result {
    type : string
    resultId : string

    constructor(item: Result) {
        this.type = item.type;
        this.resultId = item.resultId;
    }
}

export class Dependency {
    depId : string
    type : string
    depType : string | null
    depValue : number | null
    value : number | null

    constructor(item: Dependency) {
        this.depId = item.depId;
        this.type = item.type;
        this.depType = item.depType || null;
        this.depValue = item.depValue || null;
        this.value = item.value || null;
    }
}